import { File, Image as ImageIcon, Video, Music, FileText, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FileAttachmentProps {
  file: File;
  onRemove?: () => void;
  url?: string;
  showRemove?: boolean;
}

export function FileAttachment({ file, onRemove, url, showRemove = true }: FileAttachmentProps) {
  const fileType = file.type.split('/')[0];
  
  const getIcon = () => {
    if (fileType === 'image') return <ImageIcon className="h-5 w-5" />;
    if (fileType === 'video') return <Video className="h-5 w-5" />;
    if (fileType === 'audio') return <Music className="h-5 w-5" />;
    if (file.type === 'application/pdf') return <FileText className="h-5 w-5" />;
    return <File className="h-5 w-5" />;
  };

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <div className="relative group flex items-center gap-2 p-2 border border-border rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <div className="text-muted-foreground shrink-0">
          {getIcon()}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{file.name}</p>
          <p className="text-xs text-muted-foreground">{formatSize(file.size)}</p>
        </div>
      </div>
      
      {showRemove && onRemove && (
        <Button
          onClick={onRemove}
          variant="ghost"
          size="icon"
          className="h-6 w-6 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}